import React from 'react';
import { GrDocumentWord } from "react-icons/gr";
function Wordicon() {
  return (
    <div>
        <center> <GrDocumentWord style={{ color: 'cornflowerblue', fontSize: 75,width:45}} /></center>
      
    </div>
  );
}

export default Wordicon;
